import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { deleteRisk } from "../../../../../actions/Utilities/Risk";
import { toast } from "../../../../../components/toastNotification";

export default function useDisableRisk() {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids: number[]) => deleteRisk(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetRisk"]);
      toast.fire("Success", "Risk were deactivated successfully", "success");
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of Risk failed",
        "Server Error: Cannot deactivate Risk",
        "error"
      );
    },
  });

  return mutate;
}
